__turbopack_context__.v({
  "calendarButton": "U3fRjW_calendarButton",
  "firstButton": "U3fRjW_firstButton",
  "item": "U3fRjW_item",
  "pink": "U3fRjW_pink",
  "result": "U3fRjW_result",
  "secondButton": "U3fRjW_secondButton",
});
